import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "./SimplePresentationRunner";
import {FlightMode} from "../FlightMode";
import {gsap} from "gsap";

export class UseXHole implements SimplePresentation {

    shouldRun(): boolean {
        return FlightMode.model.xHoleSymbolPosition() != undefined &&
               FlightMode.model.responseWin == 0 &&
               FlightMode.model.bombPositions()[0].length == 0 &&
               FlightMode.model.allMultiplierPositions().length == 0;
    }

    public start(controller:SimplePresentationRunnerController):void {
        const xHolePosition = FlightMode.model.xHoleSymbolPosition();
        const tl = gsap.timeline();

        tl.add(() => {
            controller.setSkipCallback(() => {tl.progress(1, false)})
        })

        tl.add(() => {}, '>0.45');

        const symbols = FlightMode.reelView.symbols;
        const xHoleSymbol = symbols[xHolePosition.reel][xHolePosition.row];
        const target= xHoleSymbol.position;

        tl.add(FlightMode.reelView.moveUpSymbolAt(xHolePosition.reel, xHolePosition.row))
        tl.add(xHoleSymbol.activateXHole());
        for (let reel = 0; reel < 6; reel++) {
            for (let row = 0; row < 3; row++) {
                const symbol = symbols[reel][row];
                if (symbol.symbolName == "XH")
                    continue;

                tl.add(FlightMode.reelView.moveUpSymbolAt(reel, row), '<')
                tl.add(gsap.to(symbol.position,
                    {duration: 0.4, x: target.x, y: target.y + 15, ease:"power4.out"}), '<0.02');
                tl.add(symbol.shrinkAndDisappear(), '<');
            }
        }

        tl.add(FlightMode.reelView.updateMultiplierCounter(1), '>');
        tl.add(() => {
            for (let reel = 0; reel < 6; reel++) {
                for (let row = 0; row < 3; row++) {
                    const symbol = symbols[reel][row];
                    symbol.setMultiplier(FlightMode.model.multiplier + 1)
                }
            }
        }, '<0.3');
        tl.add(xHoleSymbol.xHoleOpenToilet(), '>0.725');

        const postXHolePositions = FlightMode.model.postXHolePositions();
        const symbolsCopy = FlightMode.reelView.symbols.map((reel) => reel.slice());
        const releaseTl = gsap.timeline();

        postXHolePositions.forEach((position) => {
            const start = position.start;
            const end = position.end;

            const symbol = symbolsCopy[start.reel][start.row];
            const targetX = (end.reel + 0.5) * 120;
            const targetY = (end.row + 0.5) * 148;
            FlightMode.reelView.setSymbolAt(end.reel, end.row, symbol);

            releaseTl.add(gsap.to(symbol.position,
                          {duration: 0.2, x: targetX, y: targetY, ease:"power4.out"}), end.reel * 0.25);
            releaseTl.add(symbol.growAndAppear(), end.reel * 0.25);
            releaseTl.add(FlightMode.reelView.moveDownSymbolAt(end.reel, end.row), end.reel * 0.25)
        })
        for (let reel = 0; reel < 6; reel++) {
            releaseTl.add(xHoleSymbol.xHoleSpit(), reel * 0.25);
            releaseTl.add(() => {
                FlightMode.soundPlayer.playSound(`xHoleReel${reel + 1}`);
            }, reel * 0.25);
        }
        tl.add(releaseTl, '>0.15');

        tl.add(xHoleSymbol.turnIntoWild(), '>-0.125');
        tl.add(FlightMode.reelView.moveDownSymbolAt(xHolePosition.reel, xHolePosition.row), '<')

        tl.add(() => {
            controller.finish();
        })
    }
}
